/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckinLiveTicketRequest } from '../../models/checkin-live-ticket-request';
import { CheckinLiveTicketResponse } from '../../models/checkin-live-ticket-response';
import { KeyType } from '../../models/key-type';

export interface PostCheckinLiveTicket$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
      body: CheckinLiveTicketRequest
}

export function postCheckinLiveTicket(http: HttpClient, rootUrl: string, params: PostCheckinLiveTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckinLiveTicketResponse>> {
  const rb = new RequestBuilder(rootUrl, postCheckinLiveTicket.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckinLiveTicketResponse>;
    })
  );
}

postCheckinLiveTicket.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/live-ticket';
